import React from "react";

function Warehouse() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#3d4a75"
        d="M25.27 106.492h30.317v358.424H25.27z"
        data-original="#3d4a75"
      ></path>
      <path
        fill="#3d4a75"
        fillRule="evenodd"
        d="M25.27 106.492l230.734-93.641 230.735 93.641v22.745H25.27z"
        data-original="#3d4a75"
      ></path>
      <path
        fill="#3d4a75"
        d="M456.421 106.492h30.317v358.424h-30.317z"
        data-original="#3d4a75"
      ></path>
      <path
        fill="#525d91"
        d="M18.566 106.492h474.878a7.564 7.564 0 017.56 7.56v77.635a7.566 7.566 0 01-7.562 7.562H18.565a7.564 7.564 0 01-7.56-7.56v-77.635a7.565 7.565 0 017.562-7.562z"
        data-original="#525d91"
      ></path>
      <path
        fill="#5d689e"
        fillRule="evenodd"
        d="M493.444 106.492H29.004v69.764c0 4.159 3.404 7.562 7.56 7.562h464.44v-69.764c0-4.159-3.403-7.562-7.56-7.562z"
        data-original="#5d689e"
      ></path>
      <path
        fill="#f0f0ff"
        d="M188.592 140.772h134.824v24.197H188.592z"
        data-original="#f0f0ff"
      ></path>
      <path
        fill="#fdd7ad"
        d="M83.016 387.383h77.533v77.533H83.016z"
        data-original="#fdd7ad"
      ></path>
      <path
        fill="#5caeff"
        fillRule="evenodd"
        d="M110.447 387.383h22.67v25.222l-11.335-5.688-11.335 5.688z"
        data-original="#5caeff"
      ></path>
      <path
        fill="#dea368"
        d="M83.016 309.85h77.533v77.533H83.016z"
        data-original="#dea368"
      ></path>
      <path
        fill="#fb545c"
        fillRule="evenodd"
        d="M110.447 309.85h22.67v25.222l-11.335-5.689-11.335 5.689z"
        data-original="#fb545c"
      ></path>
      <path
        fill="#ab733a"
        d="M160.549 232.317h77.533v77.533h-77.533z"
        data-original="#ab733a"
      ></path>
      <path
        fill="#fdc72e"
        fillRule="evenodd"
        d="M187.981 232.317h22.669v25.221l-11.334-5.688-11.335 5.688z"
        data-original="#fdc72e"
      ></path>
      <path
        fill="#e6b17c"
        d="M160.549 387.383h77.533v77.533h-77.533z"
        data-original="#e6b17c"
      ></path>
      <path
        fill="#fb545c"
        fillRule="evenodd"
        d="M187.981 387.383h22.669v25.222l-11.334-5.688-11.335 5.688z"
        data-original="#fb545c"
      ></path>
      <path
        fill="#ba8047"
        d="M160.549 309.85h77.533v77.533h-77.533z"
        data-original="#ba8047"
      ></path>
      <path
        fill="#2dd62d"
        fillRule="evenodd"
        d="M187.981 309.85h22.669v25.222l-11.334-5.689-11.335 5.689z"
        data-original="#2dd62d"
      ></path>
      <path
        fill="#e6b17c"
        d="M308.485 373.757h77.533v77.533h-77.533z"
        data-original="#e6b17c"
      ></path>
      <g fillRule="evenodd">
        <path
          fill="#f0414a"
          d="M335.917 373.757h22.669v25.222l-11.334-5.689-11.335 5.689z"
          data-original="#f0414a"
        ></path>
        <path
          fill="#fb545c"
          d="M347.252 373.757h11.334v25.222l-11.334-5.689z"
          data-original="#fb545c"
        ></path>
        <path
          fill="#29b933"
          d="M347.196 345.45c4.905-2.985 9.867-5.879 14.763-8.877 15.258-9.346 34.15-21.291 34.15-41.425V246.55l-48.857-16.454-48.857 16.454v48.598c0 5.765 1.368 10.944 4.312 15.902 8.088 13.618 28.757 24.986 44.489 34.401z"
          data-original="#29b933"
        ></path>
        <path
          fill="#2dd62d"
          d="M347.252 345.416c4.887-2.973 9.83-5.856 14.707-8.843 15.258-9.346 34.15-21.291 34.15-41.425V246.55l-48.857-16.454v115.321z"
          data-original="#2dd62d"
        ></path>
      </g>
      <path
        fill="#96602a"
        d="M160.549 232.317h8.362v77.533h-8.362z"
        data-original="#96602a"
      ></path>
      <path
        fill="#ab733a"
        d="M160.549 309.85h8.362v77.533h-8.362z"
        data-original="#ab733a"
      ></path>
      <path
        fill="#dea368"
        d="M160.549 387.383h8.362v77.533h-8.362z"
        data-original="#dea368"
      ></path>
      <path
        fill="#d19458"
        d="M83.016 309.85h8.362v77.533h-8.362z"
        data-original="#d19458"
      ></path>
      <path
        fill="#f2c496"
        d="M83.016 387.383h8.362v77.533h-8.362z"
        data-original="#f2c496"
      ></path>
      <path
        fill="#3d4a75"
        fillRule="evenodd"
        d="M188.592 140.772h-7.159v31.356h141.983v-7.159H188.592z"
        data-original="#3d4a75"
      ></path>
      <path
        fill="#dea368"
        d="M308.485 373.757h8.362v77.533h-8.362z"
        data-original="#dea368"
      ></path>
      <path
        fillRule="evenodd"
        d="M377.505 263.375a5.002 5.002 0 010 7.072l-39.668 39.702a5.093 5.093 0 01-4.239 1.419c-1.524-.209-2.905-1.119-3.667-2.471l-13.763-24.001c-1.333-2.395-.524-5.448 1.857-6.824 2.428-1.371 5.476-.543 6.857 1.852l10.477 18.329 35.097-35.078a4.973 4.973 0 017.048 0zm44.335 197.056a5.054 5.054 0 011.428 4.186l-2.666 20.372a5.001 5.001 0 01-5.62 4.305c-2.714-.357-4.667-2.867-4.286-5.605l.762-5.791c-17.096 16.777-40.049 26.253-64.193 26.253-50.526 0-91.623-41.101-91.623-91.628 0-11.81 2.191-23.306 6.572-34.168 1-2.562 3.953-3.805 6.476-2.776a5.036 5.036 0 012.81 6.505c-3.905 9.677-5.857 19.915-5.857 30.439 0 45.012 36.573 81.632 81.622 81.632a81.475 81.475 0 0057.098-23.31l-5.762.757c-2.714.362-5.238-1.567-5.619-4.305-.333-2.738 1.572-5.248 4.333-5.61l20.334-2.676a4.96 4.96 0 014.191 1.419zm-62.479-128.124c13.382-8.21 31.763-19.453 31.763-37.159v-45.007l-43.859-14.772-43.859 14.772v45.007c0 4.958 1.143 9.2 3.619 13.348 6.667 11.277 24.192 21.672 38.287 30.025.619.372 1.238.733 1.857 1.1a691.637 691.637 0 014.286-2.562c2.619-1.576 5.286-3.148 7.905-4.752zm23.668-4.129c9.81-8.114 18.096-18.715 18.096-33.03v-48.597a4.999 4.999 0 00-3.429-4.738l-48.859-16.458c-1-.348-2.143-.348-3.191 0l-48.859 16.458a5.02 5.02 0 00-3.381 4.738v48.597c0 6.739 1.619 12.777 5 18.453 3.095 5.234 7.715 10.043 13.143 14.515-10.619 4.486-20.239 10.939-28.477 19.044l.762-5.8c.333-2.738-1.572-5.248-4.333-5.605a4.957 4.957 0 00-5.572 4.305l-2.715 20.368a5.042 5.042 0 001.429 4.186 5.027 5.027 0 004.191 1.424l20.382-2.676c2.714-.362 4.667-2.871 4.286-5.61-.333-2.738-2.857-4.671-5.619-4.305l-5.714.757c8.715-8.586 19.286-15.072 30.858-19.005 6.238 4.243 12.905 8.186 19.191 11.929 1.524.886 3 1.757 4.429 2.614a4.914 4.914 0 002.572.709c.857 0 1.762-.243 2.572-.728a512.688 512.688 0 016.81-4.076c2.667-1.595 5.333-3.186 7.953-4.81 2.762-1.695 5.81-3.557 8.953-5.624 33.192 11.239 55.383 42.002 55.383 77.313 0 10.524-2 20.763-5.858 30.44a4.976 4.976 0 002.762 6.505 5.039 5.039 0 006.524-2.776 91.88 91.88 0 006.572-34.168c0-20.001-6.334-39.006-18.334-54.954-9.667-12.891-22.763-23.096-37.525-29.392zm-69.527 50.578v67.531h67.527v-67.531H363.6v20.225a5.019 5.019 0 01-5 5.001 4.989 4.989 0 01-2.238-.533l-9.096-4.562-9.095 4.562a4.985 4.985 0 01-4.857-.214 5 5 0 01-2.381-4.253v-20.225h-17.429zm27.43 0v12.119l4.095-2.057c1.381-.705 3.048-.705 4.477 0l4.095 2.057v-12.119zm45.097 77.532a5 5 0 005-5v-77.531a5 5 0 00-5-5h-77.527a5 5 0 00-5 5v77.531a5 5 0 005 5zm-67.622-296.322H193.592v-14.191h124.815zm5-24.192H188.593c-2.762 0-5 2.233-5 5v24.191a5 5 0 005 5h134.815a5 5 0 005-5v-24.191c0-2.767-2.238-5-5-5zm172.579 55.912v-77.632c0-1.391-1.143-2.562-2.524-2.562H18.585a2.577 2.577 0 00-2.572 2.562v77.632a2.577 2.577 0 002.572 2.562h474.877c1.381 0 2.524-1.172 2.524-2.562zm-14.239 268.23h-20.334V204.248h20.334zm-431.161 0H30.253V204.248h20.334v255.668zm205.438-441.67l205.104 83.246H50.872zm237.438 83.246H487.7L257.881 8.217a4.998 4.998 0 00-3.762 0L24.3 101.492h-5.714c-6.953 0-12.572 5.634-12.572 12.563v77.632c0 6.929 5.619 12.563 12.572 12.563h1.667v260.666a5 5 0 005 5h30.335a5 5 0 005-5V204.248h390.825v260.668a5 5 0 005 5h30.334a5 5 0 005-5V204.248h1.714c6.905 0 12.524-5.634 12.524-12.563v-77.631c0-6.929-5.619-12.563-12.524-12.563zM165.544 459.916V392.38h17.429v20.225c0 1.733.905 3.343 2.381 4.257 1.476.905 3.334.99 4.857.209l9.096-4.562 9.096 4.562a4.989 4.989 0 002.238.533c.905 0 1.857-.253 2.619-.743a5.015 5.015 0 002.381-4.257v-20.225h17.429v67.536h-67.527zM88.017 392.38h17.429v20.225c0 1.733.905 3.343 2.381 4.257a4.982 4.982 0 004.857.209l9.096-4.562 9.096 4.562a4.989 4.989 0 002.238.533c.905 0 1.81-.253 2.619-.743a5.015 5.015 0 002.381-4.257v-20.225h17.429v67.536H88.017v-67.536zm27.43 0h12.667v12.119l-4.095-2.053a4.978 4.978 0 00-4.477 0l-4.095 2.053zm-10-77.532v20.225a5 5 0 002.381 4.252 4.98 4.98 0 004.857.214l9.096-4.562 9.096 4.562a4.989 4.989 0 002.238.533c.905 0 1.81-.252 2.619-.748a5 5 0 002.381-4.252v-20.225h17.429v67.536H88.017v-67.536h17.429zm10 0h12.667v12.12l-4.095-2.052a4.978 4.978 0 00-4.477 0l-4.095 2.052zm77.527 0h12.667v12.12l-4.095-2.052c-1.381-.709-3.048-.709-4.477 0l-4.095 2.052zm-27.43 67.536v-67.536h17.429v20.225a5 5 0 002.381 4.252c1.476.91 3.334.991 4.857.214l9.096-4.562 9.096 4.562a4.989 4.989 0 002.238.533c.905 0 1.857-.252 2.619-.748a5 5 0 002.381-4.252v-20.225h17.429v67.536h-67.527zm27.43 9.996h12.667v12.119l-4.095-2.053c-1.381-.709-3.048-.709-4.477 0l-4.095 2.053zm-10-155.064v20.22c0 1.738.905 3.348 2.381 4.257s3.334.99 4.857.214l9.096-4.562 9.096 4.562a5.05 5.05 0 002.238.528c.905 0 1.857-.247 2.619-.743a5.003 5.003 0 002.381-4.257v-20.22h17.429v67.532h-67.527v-67.532h17.429zm10 0h12.667v12.12l-4.095-2.057c-1.381-.705-3.048-.705-4.477 0l-4.095 2.057zm45.097-10a5 5 0 015 5v232.6a5 5 0 01-5 5H83.017a5 5 0 01-5-5V309.848c0-2.757 2.238-5 5-5h72.527v-72.532a5 5 0 015-5z"
        data-original="#000000"
      ></path>
    </svg>
  );
}

export default Warehouse;
